import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import styled from 'styled-components';

export const StyledGreenAvatar = styled(Avatar)`
    background-color: #3f51b5;
`;

export const StyledList = styled(List)`
    display: flex;
`;

export const StyledListFullWidth = styled(StyledList)`
    width: 100%;

    & > li {
        width: 100%;
    }
`;


export const StyledListItem = styled(ListItem)`
    padding: 4px 8px;
`;
